/**
 * Created by Kirill Mashchenko on 12.07.19.
 */

/**
 * @class Layer for kumir robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var KumirRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends KumirRobotSettingsLayer# */{
	// _paintLabel: null,
	// _paintValue: 0,

	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Kumir") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
